import { render, staticRenderFns } from "./OkrCollapseItem.vue?vue&type=template&id=fa693b9c"
import script from "./OkrCollapseItem.vue?vue&type=script&lang=js"
export * from "./OkrCollapseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports